/**
 * * Модель получения хлебных крошек
 */
export class SettingsBreadcrumbsModel {
  /**ID проекта */
  readonly ProjectId: number;
  /**ID рабочей области */
  readonly NamespaceId: string;
  /**ID группы */
  readonly GroupId: number;
  /**ID очереди */
  readonly QueueId: string;

  constructor(obj?: Partial<SettingsBreadcrumbsModel>) {
    Object.assign(this, obj);
  }
}
